import React from 'react';
import { motion } from 'framer-motion';
import { Book, Heart, Moon, Shield, Anchor, Sun } from 'lucide-react';
export function ProductContents() {
  const chapters = [{
    icon: Heart,
    title: 'Cómo orar cuando no tienes palabras',
    desc: 'El lenguaje de las lágrimas que Dios entiende mejor que cualquier discurso.'
  }, {
    icon: Moon,
    title: 'El silencio de Dios',
    desc: 'Lo que el Sábado Santo nos enseña sobre los momentos donde Dios parece ausente.'
  }, {
    icon: Shield,
    title: 'Soltar la carga de la ansiedad',
    desc: 'No es un truco psicológico. Es una postura espiritual con 2,000 años de historia.'
  }, {
    icon: Anchor,
    title: '40 encuentros que no te piden ser fuerte',
    desc: 'Solo te piden ser entregado. Hay una diferencia enorme.'
  }, {
    icon: Sun,
    title: 'Tu plan de regreso personal',
    desc: 'Cómo identificar tus señales de estrés espiritual y volver al refugio antes de caer.'
  }];
  return <section className="py-20 px-6 bg-[var(--bg-deep)]" data-id="element-260">
      <div className="max-w-[800px] mx-auto" data-id="element-261">
        <div className="text-center mb-16" data-id="element-262">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block mb-8 relative" data-id="element-263">
            <div className="absolute inset-0 bg-[var(--accent)] blur-[80px] opacity-10 rounded-full" data-id="element-264"></div>
            <img src="https://cdn.magicpatterns.com/uploads/m2Nc5dQ243QcHZ1mxcHfG1/ebook_cover.png" alt="Book Cover" className="w-48 md:w-64 rounded shadow-2xl relative z-10 border border-[var(--bg-elevated)]" data-id="element-265" />
          </motion.div>

          <h2 className="text-3xl md:text-4xl font-serif text-[var(--text-heading)] mb-4" data-id="element-266">
            Cuando Dios es lo único que te queda
          </h2>
          <p className="text-[var(--text-muted)] uppercase tracking-widest text-sm mb-8" data-id="element-267">
            40 Encuentros que transforman el dolor en fe
          </p>

          <p className="text-lg text-[var(--text-primary)] max-w-2xl mx-auto leading-relaxed" data-id="element-268">
            Este no es un libro de teología. <br data-id="element-269" />
            <span className="text-[var(--accent)] font-serif italic text-xl" data-id="element-270">
              Es una balsa de rescate diseñada para tu peor momento.
            </span>
          </p>
        </div>

        <div className="grid gap-6" data-id="element-271">
          {chapters.map((chapter, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex gap-5 p-6 bg-[var(--bg-elevated)] rounded-lg border border-transparent hover:border-[var(--accent)]/20 transition-all group" data-id="element-272">
              <div className="flex-shrink-0 pt-1" data-id="element-273">
                <chapter.icon className="w-6 h-6 text-[var(--accent)] opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-274" />
              </div>
              <div data-id="element-275">
                <h3 className="text-[var(--text-heading)] font-serif text-lg mb-2 group-hover:text-[var(--accent)] transition-colors" data-id="element-276">
                  {chapter.title}
                </h3>
                <p className="text-[var(--text-muted)] text-sm leading-relaxed" data-id="element-277">
                  {chapter.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}